import { render, staticRenderFns } from "./KeyboardSlide.vue?vue&type=template&id=4432a865&scoped=true"
import script from "./KeyboardSlide.vue?vue&type=script&lang=ts"
export * from "./KeyboardSlide.vue?vue&type=script&lang=ts"
import style0 from "./KeyboardSlide.vue?vue&type=style&index=0&id=4432a865&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4432a865",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection,QIcon,QBtn,QDialog,QCardActions,QImg});
